import {
  menu,
  type MenuConfig,
} from '@blocksuite/affine-components/context-menu';

import { typeSystem } from '../../../../../../core';
import { dataViewI18nT } from '../../../../../../core/i18n';
import { statsFunctions } from '../../../../../../core/statistics';
import type { StatisticsConfig } from '../../../../../../core/statistics/types';
import type { TableProperty } from '../../../../table-view-manager';

function getStatisticsGroups(column: TableProperty) {
  const groups: Record<string, Record<string, StatisticsConfig>> = {};

  statsFunctions.forEach(func => {
    if (!typeSystem.unify(column.dataType$.value, func.dataType)) {
      return;
    }
    if (!groups[func.group]) {
      groups[func.group] = {};
    }
    const oldFunc = groups[func.group]?.[func.type];
    if (!oldFunc || typeSystem.unify(func.dataType, oldFunc.dataType)) {
      if (!func.impl) {
        delete groups[func.group]?.[func.type];
      } else {
        const group = groups[func.group];
        if (group) {
          group[func.type] = func;
        }
      }
    }
  });

  return groups;
}

export function findColumnStatisticsFunction(
  column: TableProperty,
  type: string | undefined
) {
  return Object.values(getStatisticsGroups(column))
    .flatMap(group => Object.values(group))
    .find(func => func.type === type);
}

export function createColumnStatisticsMenuItems(
  column: TableProperty
): MenuConfig[] {
  const groups = Object.entries(getStatisticsGroups(column)).map(
    ([group, funcs]) =>
      menu.subMenu({
        name: group,
        options: {
          items: Object.values(funcs).map(func =>
            menu.action({
              isSelected: func.type === column.statCalcOp$.value,
              name: func.menuName ?? func.type,
              select: () => column.updateStatCalcOp(func.type),
            })
          ),
        },
      })
  );

  return [
    menu.action({
      isSelected: !column.statCalcOp$.value,
      name: dataViewI18nT('statistics.none'),
      select: () => column.updateStatCalcOp(),
    }),
    ...groups,
  ];
}

export function createColumnStatisticsSubMenu(column: TableProperty) {
  return menu.subMenu({
    name: dataViewI18nT('statistics.calculate'),
    options: {
      items: createColumnStatisticsMenuItems(column),
    },
  });
}
